import React, { useState } from "react";
import useSupportContactForm from "../hooks/useSupportContactForm";

const SupportContactForm = () => {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [validationError, setValidationError] = useState("");
  const { isSubmitting, error, success, submitContactForm, clearMessages } =
    useSupportContactForm();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedSubject = subject.trim();
    const trimmedMessage = message.trim();

    if (!trimmedSubject || !trimmedMessage) {
      setValidationError("Subject and message are required.");
      return;
    }

    setValidationError("");
    clearMessages();

    const didSubmit = await submitContactForm({
      subject: trimmedSubject,
      message: trimmedMessage,
    });

    if (didSubmit) {
      setSubject("");
      setMessage("");
    }
  };

  return (
    <div className="mt-5 rounded-xl border border-line bg-white px-4 py-4 sm:px-6">
      <div>
        <h2 className="text-lg font-bold text-primary">Contact Support</h2>
        <p className="text-xs text-muted mt-1">
          Send us a message and we&apos;ll get back to you within 24 hours
        </p>
      </div>

      {validationError || error ? (
        <div className="mt-4 rounded-md border border-danger/20 bg-danger/5 px-4 py-3 text-sm text-danger">
          {validationError || error}
        </div>
      ) : null}

      {success ? (
        <div className="mt-4 rounded-md border border-success/20 bg-success/5 px-4 py-3 text-sm text-success">
          {success}
        </div>
      ) : null}

      <form className="mt-4 space-y-3" onSubmit={handleSubmit}>
        <fieldset className="rounded-md border border-primary px-3 pb-2 pt-0.5">
          <legend className="px-1 text-xs text-primary">Subject</legend>
          <input
            value={subject}
            onChange={(event) => setSubject(event.target.value)}
            placeholder="Brief description of your issue"
            className="w-full border-0 px-0 py-1.5 text-sm text-content outline-none placeholder:text-muted/70"
            maxLength={120}
          />
        </fieldset>

        <fieldset className="rounded-md border border-primary px-3 pb-2 pt-0.5">
          <legend className="px-1 text-xs text-primary">Message</legend>
          <textarea
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="Provide detailed information about your issues"
            className="min-h-[140px] w-full resize-y border-0 px-0 py-1.5 text-sm text-content outline-none placeholder:text-muted/70"
            maxLength={2000}
          />
        </fieldset>

        <div className="flex justify-end">
          <button
            type="submit"
            disabled={isSubmitting}
            className="rounded-md bg-primary px-5 py-2 text-xs font-semibold text-white transition-colors hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-70"
          >
            {isSubmitting ? "SUBMITTING..." : "SUBMIT TICKET"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default SupportContactForm;